/**
 * 环境配置管理
 */

// 获取环境变量的辅助函数
const getEnv = (key, defaultValue = "") => {
  return process.env[key] || defaultValue;
};

// 环境配置
export const config = {
  // 基础配置
  NODE_ENV: getEnv("NODE_ENV", "development"),

  // 应用配置
  APP_TITLE: getEnv("VUE_APP_TITLE", "单词记忆应用家长端"),
  DEBUG: getEnv("VUE_APP_DEBUG", "false") === "true",

  // API 配置
  API_BASE_URL: getEnv("VUE_APP_API_BASE_URL", "/api"),
  API_PROXY_TARGET: getEnv("VUE_APP_API_PROXY_TARGET", "http://local.words.com"),
  USE_MOCK: getEnv("VUE_APP_USE_MOCK", "true") === "true",
  USE_MOCK_PARENT: getEnv("VUE_APP_USE_MOCK_PARENT", "true") === "true",

  // 功能开关
  ENABLE_CONSOLE_LOG: getEnv("VUE_APP_ENABLE_CONSOLE_LOG", "true") === "true",
  ENABLE_ERROR_REPORTING:
    getEnv("VUE_APP_ENABLE_ERROR_REPORTING", "false") === "true",
};

// 环境判断
export const isDevelopment = config.NODE_ENV === "development";
export const isProduction = config.NODE_ENV === "production";
export const isTest = config.NODE_ENV === "test";

// 打印当前配置（仅在开发环境）
if (isDevelopment && config.DEBUG) {
  console.log("🔧 当前环境配置:", config);
}

export default config;
